import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import { DEFAULT_FILTER } from '../admin/user';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../consts/table';
import { Count } from '../../../models/count';

export function getTournamentConfirmationRequests(user: AppUser, tournamentId, filter = DEFAULT_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      summary: true,
      filter
    }
  };

  return axios
    .get(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/messages/confirmationRequest`,
      config
    )
    .then(response => {
      return response.data;
    });
}

export function getTournamentConfirmationRequestsCount(user: AppUser, tournamentId, where?): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where
        }
      }
    };
  } else {
    config = {
      headers: { usid: key }
    };
  }

  return axios
    .get<Count>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/messages/confirmationRequest/count`,
      config
    )
    .then(response => {
      return response.data;
    });
}

export function getAllTournamentConfirmationRequests(user: AppUser, tournamentId, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  }

  return axios
    .get(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/messages/confirmationRequest`,
      config
    )
    .then(response => {
      return response.data;
    });
}
